import React from "react";
import "./Education.scss";

const Education = ({ componentOffsetTop }) => {
  return (
    <div
      id="education"
      className="education"
      ref={(e) => (componentOffsetTop.current[4] = e)}
    >
      <h1>EDUCATION</h1>
      <div className="education-container">
        <div className="circle-date-one"></div>
        <div className="part-two">
          <i className="cap fas fa-graduation-cap"></i>
          <p>Computer Software Engineering</p>
          <p>Azad Univercity</p>
          <p>Associate degree</p>
          <p>IRAN - Neyshabour</p>
        </div>
        <div className="circle-date-two"></div>
        <div className="part-two">
          <i className="cap fas fa-graduation-cap"></i>
          <p>Information Technology (IT Security)</p>
          <p>Mokhaberat Univercity</p>
          <p>Bachlore degree</p>
          <p>IRAN - Mashhad</p>
        </div>
        <div className="circle-date-four"></div>
        <div className="part-four">
          <i className="cap fas fa-graduation-cap"></i>
          <p>Full Stack Web Developer</p>
          <p>Code Your Future</p>
          <p>Graduation</p>
          <p>UK - London</p>
        </div>
        <div className="circle-date-five"></div>
      </div>
    </div>
  );
};

export default Education;
